export const SITE_URL = 'https://aitria.co.jp'
export const ORGANIZATION_ID = `${SITE_URL}/#organization`
export const ORGANIZATION_NAME = 'Aitria株式会社'
export const ORGANIZATION_ALTERNATE_NAME = 'Aitria Co., Ltd.'
export const ORGANIZATION_FORMER_NAME = '株式会社アイスリーデザイン'
export const ORGANIZATION_ANNOUNCEMENT_URL = `${SITE_URL}/pressrelease/5170/`
export const SERVICE_OGP_IMAGE = `${SITE_URL}/img/ogp_logo.png`
export const WEBSITE_NAME = 'Aitria'
